import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet'
import { File, Save, ChevronLeft } from 'react-feather'
import { Link, useHistory, useParams, useLocation } from 'react-router-dom'
import { useForm } from "react-hook-form"
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux'

// variables
import { SITENAME } from '../../configuration.js';

// components
import PageHead from '../../components/PageHead';
import Loading from '../../components/Loading';
import ContentEditorFull from '../../components/ContentEditor/full';

// controllers
import _actions from '../../controllers/redux/actions'
import { _apiGETone, _apiPOST, _apiPUT, _apiAvailability } from '../../controllers/Api';
import { _goBack } from '../../controllers/Helpers';


export default function TemplateFormDocument(props){

  const dispatch = useDispatch();
  const auth = dispatch(_actions.auth.authStatus());

  const location = useLocation()
  const history = useHistory()
  const { id } = useParams()

  const isBackPossible = _goBack(location)

  const fields = {
    title: '',
    key: '',
    template: ''
  }

  const [ loading, setLoading ] = React.useState(true);
  const [ formData, setFormData ] = React.useState(fields)

  const { register, handleSubmit, setValue, formState: { errors } } = useForm();
  const [ available1, setAvailable1 ] = React.useState(true)


  //
  //
  const _updateField = (field, data) => {
    setFormData({...formData, [field]:data});
  }


  //
  //
  const _handleEditorChange = (content, editor) => {
    setFormData({...formData, template:content})
  }


  //
  //
  React.useEffect(()=>{

    setLoading(true)

    let route = '/main-documents/'
    if(auth.response.role>2){
      route = '/documents/'
    }

    const getData = async () =>{
      if(id !== 'new'){
        const res = await _apiGETone(route+id)
        if(res.error){
          toast.error(res.error.message);
        }else{
          setFormData({...res})
          setValue('title', res.title)
          setValue('template', res.template)
          setValue('key', res.key)
        }
      }
      setLoading(false)
    }
    if(auth.status){
      getData()
    }

    return (() => [getData])
  },[id, auth.status, setValue, auth.response.role])


  //
  //
  const _title = () =>{
    return `Templates / Documents - ${id==='new' ? 'New entry' : 'Update'}`
  }


  //
  //
  const _submit = async () => {

    let route = '/main-documents/'
    if(auth.response.role>2){
      route = '/documents/'
    }

    if(id==='new'){

      delete formData.passwordConfirm

      const insert = await _apiPOST(route, formData)
      if(insert.error){
        toast.error(insert.error.message);
      }else{
        toast.success(insert.message);
        history.push('/templates/documents/')
      }

    }else{

      delete formData.dateCreated
      delete formData.dateUpdated
      delete formData._id

      const update = await _apiPUT(route+id, formData)
      if(update.error){
        toast.error(update.error.message);
      }else{
        toast.success(update.message);
        history.push('/templates/documents/')
      }

    }

  }



  //
  //
  const _checkAvailability = async(value) => {

    const isAvailable = await _apiAvailability('docKey', value)
    if(isAvailable){
      setAvailable1(true)
    }else{
      setAvailable1(false)
    }

  }


  //
  //
  React.useEffect(() => {
    const timeoutId = setTimeout(() => auth.response.role <= 1 && formData.key !== '' ? _checkAvailability({key:formData.key, id:formData._id}) : null, 1000 );
    return () => clearTimeout(timeoutId);
  }, [formData.key, formData._id]);



  //
  //
  return (
    <Fragment>
      <Helmet>
        <title>{_title()} | { SITENAME }</title>
      </Helmet>

      <form onSubmit={handleSubmit(_submit)} autoComplete="off" className="w-100">
      <PageHead
        title={_title()}
        icon={<File size={52}/>}
      >
        {isBackPossible && <Link to={isBackPossible} className="button accent lg outline ml-1"><ChevronLeft/> back</Link>}
        <button className="button accent lg ml-1"><Save/>save</button>
      </PageHead>

      <div className="relative w-100">

        <div className="row">
          <div className="col-12">

            <div className="row">
              <div className="col-lg-9">
                <div className="form-group">
                  <label>Title</label>
                  <input
                    {...register("title", { required: true })}
                    type="text"
                    name="title"
                    value={formData.title}
                    onChange={(e)=>_updateField('title',e.target.value)}
                    className={`form-control ${errors.title && 'error'}`}
                  />
                  {errors.title && <div className="errorField">This field is required</div>}
                </div>
              </div>
              <div className="col-lg-3">
                <div className="form-group">
                  <label>Template key</label>
                  <div className="relative">
                  <input
                    {...register("key", { required: auth.response.role <= 2 ? true : false })}
                    type="text"
                    name="key"
                    value={formData.key}
                    onChange={(e)=>_updateField('key',e.target.value)}
                    className={`form-control ${errors.key && 'error'}`}
                  />
                  {auth.response.role <= 1 &&
                    <>
                    {!available1 && formData.key !== '' && <div className="errorCheck">Taken</div>}
                    {available1 && formData.key !== '' && <div className="successCheck">Available</div>}
                    </>
                  }
                  </div>
                  {errors.key && <div className="errorField">This field is required</div>}
                </div>
              </div>
            </div>

            <div className="form-group">
              <label>Template content</label>
              <ContentEditorFull
                value={formData.template}
                initialValue={formData.template}
                onEditorChange={_handleEditorChange}
              />
            </div>

          </div>
        </div>

        <Loading status={loading}/>
      </div>
      </form>

    </Fragment>
  );

}
